import React from "react";
import { Star } from "lucide-react";

import styles from "./AvaliacaoEstrelas.module.scss";

interface Props {
  rating?: number;
  total?: number;
  size?: number;
  onChange?: (rating: number) => void;
}

export const AvaliacaoEstrelas: React.FC<Props> = ({
  rating = 0,
  total = 0,
  size = 16,
  onChange,
}) => {
  const fullStars = Math.floor(rating);

  return (
    <div className={styles.container}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          size={size}
          className={
            star <= fullStars
              ? styles.starFilled
              : styles.starEmpty
          }
          onClick={
            onChange
              ? () => onChange(star)
              : undefined
          }
          style={{
            cursor: onChange ? "pointer" : "default",
          }}
        />
      ))}

      {total > 0 && (
        <span className={styles.total}>
          ({total})
        </span>
      )}
    </div>
  );
};